import { type ReactNode } from 'react';
import { Divider } from '@flintmint/web-shared/components/divider';

import styles from './preference-card.module.scss';

export const PreferenceCard = (props: PreferenceCardProps) => {
  const { title, description, subTitle, subDescription, action } = props;

  return (
    <section className={styles.preferenceCard}>
      <header>
        <h4>{title}</h4>
        <p>{description}</p>
      </header>
      <Divider orientation="horizontal" size="100%" />
      <div className={styles.setting}>
        <div>
          <h5>{subTitle}</h5>
          <p>{subDescription}</p>
        </div>
        {action}
      </div>
    </section>
  );
};

interface PreferenceCardProps {
  title: string;
  subTitle: string;
  subDescription: string;
  description: string;
  action: ReactNode;
}
